import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../../actions/customer';
import Form from './Form';

export class CustomerOrderCreate extends React.Component { 

	componentDidMount () {
		this.props.actions.formOrderCreate();
	}

	render () {
		return (
			<div>
			<h2 className="title-form">Dodawanie nowego zlecenia</h2>
			<Form action={this.props.actions.createOrder} />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrderCreate);


/** WEBPACK FOOTER **
 ** ./js/views/customer/order/Create.js
 **/